module.exports = __webpack_public_path__ + "img/Image16.477740ba.jpg";